import React, { useEffect } from "react";
import { useParams } from "react-router";
import { User } from "../../../../../models/user";
import { AxiosHttpClient } from "../../../../../services/AxiosHttpService";
import { useSingleUserPresence } from "../../../../Reusable/UseSingleUserPresence";
import ExpertPage from "./ExpertPage";
import UserPage from "./UserPage";

export default function ProfilePage() {
  const getUser = () => {
    AxiosHttpClient.get<User>("api/v1/docuveritas/users/" + params.userId).then(
      (response) => {
        setUser(response);
      }
    );
  };

  const params = useParams<{ userId: string }>();
  const [user, setUser] = useSingleUserPresence();

  useEffect(() => {
    getUser();
  }, [params.userId]);

  return (
    <>
      {user?.roles.includes("EXPERT") && <ExpertPage user={user} />}
      {user?.roles.includes("USER") && <UserPage user={user} />}
    </>
  );
}
